import type { PointerEvent } from "react";

export type ResizeAnchor = "n" | "ne" | "e" | "se" | "s" | "sw" | "w" | "nw";

const ANCHORS: readonly ResizeAnchor[] = ["n", "ne", "e", "se", "s", "sw", "w", "nw"];

interface ResizeHandlesProps {
  onAnchorDown: (anchor: ResizeAnchor, e: PointerEvent<HTMLDivElement>) => void;
  onMove: (e: PointerEvent<HTMLDivElement>) => void;
  onEnd: (e: PointerEvent<HTMLDivElement>) => void;
}

export function ResizeHandles({ onAnchorDown, onMove, onEnd }: ResizeHandlesProps): JSX.Element {
  return (
    <>
      {ANCHORS.map((a) => (
        <div
          key={a}
          className={`canvas-resize-handle canvas-resize-handle-${a}`}
          data-anchor={a}
          onPointerDown={(e) => onAnchorDown(a, e)}
          onPointerMove={onMove}
          onPointerUp={onEnd}
          onPointerCancel={onEnd}
        />
      ))}
    </>
  );
}
